import '@fontsource/cinzel/600.css';
import '@fontsource/cinzel/700.css';
import '@fontsource/cormorant-garamond/500.css';
import '@fontsource-variable/inter';
import './styles/global.css';
import './i18n';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { router } from './router';
import { useSettings } from './stores/settings';

// `?render=2d|3d` fuerza el modo de la mesa (útil en pruebas y equipos lentos).
const forced = new URLSearchParams(window.location.search).get('render');
if (forced === '2d' || forced === '3d') useSettings.getState().update({ render: forced });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
